/*
 * An OSS line's VAT code: the org's OSS code (DK SM-X-OSS-S, DE UST-X-OSS-G...)
 * at one of the customer's country's rates. The code itself has no rate — the
 * destination country's applies — so GET vatTax offers one entry per rate,
 * and its id says which:
 *
 *   SM-X-OSS-S@DE@0.19      OSS services, Germany, 19 %
 *
 * A line keeps that id. findVatTax resolves it to the base code with the rate
 * and country filled in, so posting has a real rate, two lines at different
 * rates stay in separate VAT groups, and the OSS return can sum per country
 * and rate. No imports: resolveVatTax.js reads it, and so does the OSS return
 * on the client (ossReturn.js).
 */
const SEP = '@';

export const ossVariantId = (baseId, country, rate) => `${baseId}${SEP}${country}${SEP}${rate}`;

/** `{ baseId, country, rate }` for an OSS variant id, else null. */
export const parseOssVariant = (id) => {
    const parts = String(id ?? '').split(SEP);
    if (parts.length !== 3) return null;
    const [baseId, country, raw] = parts;
    const rate = Number(raw);
    if (!baseId || !/^[A-Z]{2}$/.test(country) || raw === '' || !Number.isFinite(rate) || rate < 0 || rate >= 1) return null;
    return { baseId, country, rate };
};
